import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ModalDataState {
  data: any;
}

const initialState: ModalDataState = {
  data: undefined,
};

const modalDataSlice = createSlice({
  name: 'modalData',
  initialState,
  reducers: {
    sendData: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
    },
  },
});

export const { sendData } = modalDataSlice.actions;
export default modalDataSlice.reducer;
